import { useState, useCallback } from 'react'
import { useTheme, Theme } from '@emotion/react'
import { useSpring, SpringValue } from 'react-spring'

interface Hooks {
  isHovered: boolean
  setHover: () => void
  resetHover: () => void
  underlineSpring: Record<string, SpringValue>
  containerSpring: Record<string, SpringValue>
  theme: Theme
}

export function useHooks(): Hooks {
  const theme = useTheme()

  const [isHovered, setIsHovered] = useState(false)

  const setHover = useCallback(() => {
    setIsHovered(true)
  }, [])

  const resetHover = useCallback(() => {
    setIsHovered(false)
  }, [])

  let color = theme.colors.secondary[900]
  if (isHovered) {
    color = theme.colors.primary[400]
  }

  const underlineSpring = useSpring({
    from: {
      transform: 'translate3d(0, 100%, 0)',
      backgroundColor: color,
    },
    to: {
      transform: isHovered
        ? 'translate3d(0, 0%, 0)'
        : 'translate3d(0, 100%, 0)',
      backgroundColor: color,
    },
    config: {
      mass: 1,
      tension: 200,
      friction: 30,
    },
  })

  const containerSpring = useSpring({
    from: {
      color: color,
    },
    to: {
      color: color,
    },
    config: {
      mass: 1,
      tension: 200,
      friction: 30,
    },
  })

  return {
    isHovered,
    setHover,
    resetHover,
    underlineSpring,
    containerSpring,
    theme,
  }
}
